import dealApi from '../apis/deal'
import loveboxApi from '../apis/lovebox'

const state = {
  mergeList: {
    total: 0,
    curPage: 0,
    data: [],
    nextPageUrl: '//'
  },
  category: {
    gift_request: {
      requesting_total: '',
      remitting_total: '',
      remitted_total: '',
      sent_total: '',
      finished_total: '',
      lovebox_not_thank_total: '',
      lovebox_remitted_total: '',
      lovebox_remitting_total: '',
      lovebox_sent_total: ''
    },
    need_donate: {
      init_total: '',
      remitting_total: '',
      remitted_total: '',
      sent_total: ''
    }
  },
  demands: {
    curIdx: 0,
    gift: {
      total: 0,
      curPage: 0,
      data: [],
      nextPageUrl: '//'
    },
    need: {
      total: 0,
      curPage: 0,
      data: [],
      nextPageUrl: '//'
    },
    requesting: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    remitting: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    remitted: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    sent: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    finished: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    search: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    }
  },
  donates: {
    curIdx: 0,
    gift: {
      total: 0,
      curPage: 0,
      data: [],
      nextPageUrl: '//'
    },
    need: {
      total: 0,
      curPage: 0,
      data: [],
      nextPageUrl: '//'
    },
    init: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    remitting: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    remitted: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    },
    sent: {
      curIdx: 0,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    }
  },
  palmNotTakeOrders: {
    giftRequests: [],
    needDonates: []
  },
  payDealInfo: {},
  updateChatroomInfo: { // 當送給他頁面進行了合併操作，需要更新互動卡為parent gift_request的會話
    need: false,
    type: '',
    dealId: 0,
    directUserId: 0,
    oldDealId: 0
  },
  dealInfo: null,
  dealType: '',
  updateChatroomDealInfo: null
}

const actions = {
  getShipsnPic ({commit, state}, {id, cb = null} = {}) {
    dealApi.getShipsnPic(
      id,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getDealsCategory ({commit, state}, {cb = null} = {}) {
    dealApi.getDealsCategory(
      (data) => {
        commit('setDealsCategory', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMyDemands ({commit, state}, {page, type, status, cb = null} = {}) {
    dealApi.getMyDemands(
      page,
      type,
      status,
      (data) => {
        if (data && !data.error) {
          commit('setMyDemands', {type: type === 'lovebox_v2' ? 'lovebox' : type, status, data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMyDonates ({commit, state}, {page, type, status, cb = null} = {}) {
    dealApi.getMyDonates(
      page,
      type,
      status,
      (data) => {
        if (data && !data.error) {
          commit('setMyDonates', {type, status, data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  searchMyDemands ({ commit }, { page, type, status, shipway, shipsn }) {
    return dealApi.searchMyDemand(page, type, status, shipway, shipsn)
      .then((data) => {
        commit('setSearchDemands', { type, data })
        return data
      })
  },
  getConversationId ({commit, state}, {id, tab, type, dirUserId, cb = null} = {}) {
    dealApi.getConversationId(
      id,
      tab,
      type,
      dirUserId,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getDemandTotal ({commit, state}, {type, status, cb = null} = {}) {
    dealApi.getDemandTotal(
      type,
      status,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getDonateTotal ({commit, state}, {type, status, cb = null} = {}) {
    dealApi.getDonateTotal(
      type,
      status,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMyToThankLoveboxTotal ({commit, state}, {cb = null} = {}) {
    return loveboxApi.getToThankLoveboxTotal()
  },
  getMyToThankLoveboxes ({commit, state}, {page, status, cb = null}) {
    return loveboxApi.getToThankLoveboxes(page, 10, (data) => {
      if (data && !data.error) {
        commit('setMyDemands', { type: 'lovebox', status, data })
      }
      cb && cb(data)
    })
  },
  dealMerge ({commit, state}, {ids = [], type = 'gift', cb = null} = {}) {
    dealApi.dealMerge(
      ids,
      type,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMergeList ({commit, state}, {page, perPage, cb = null} = {}) {
    dealApi.getMergeList(
      page,
      perPage,
      (data) => {
        if (data && !data.error) {
          commit('setMergeList', data)
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  processMerge ({commit, state}, {giftRequestId, status, mergeRejectedReason, cb = null} = {}) {
    dealApi.processMerge(
      giftRequestId,
      status,
      mergeRejectedReason,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getPalmBoxNotTakeOrders ({commit}) {
    dealApi.getPalmBoxNotTakeOrders()
      .then(res => {
        commit('setPalmBoxNotTakeOrders', res)
      })
      .catch(err => {
        console.log(err)
      })
  },
  remindReceiverPickUp ({ commit, dispatch }, { id, type }) {
    if (type === 'gift') {
      return dealApi.remindGiftRequest(id)
        .then((res) => {
          commit('updateSentDonates', { type, data: res.data })
          dispatch('getDealsCategory')
          return res.data
        })
    } else if (type === 'need') {
      return dealApi.remindNeedDonate(id)
        .then((res) => {
          commit('updateSentDonates', { type, data: res.data })
          dispatch('getDealsCategory')
          return res.data
        })
    }
  }
}

const mutations = {
  setDealsCategory (state, {data}) {
    if (data && !data.error && data.gift_request && data.need_donate) {
      state.category = data
    }
  },
  setMyDemands (state, {type, status, data}) {
    if (type === 'present') {
      if (status) {
        state.demands[status].need = {
          ...state.demands[status].need,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }

        if (data.current_page === 1) {
          state.demands[status].need.data = data.data
        } else {
          state.demands[status].need.data = state.demands[status].need.data.concat(data.data)
        }
      } else {
        state.demands.need = {
          ...state.demands.need,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }

        if (data.current_page === 1) {
          state.demands.need.data = data.data
        } else {
          state.demands.need.data = state.demands.need.data.concat(data.data)
        }
      }
    } else if (type === 'lovebox') {
      if (status) {
        state.demands[status].lovebox = {
          ...state.demands[status].lovebox,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }

        if (data.current_page === 1) {
          state.demands[status].lovebox.data = data.data
        } else {
          state.demands[status].lovebox.data = state.demands[status].lovebox.data.concat(data.data)
        }
      } else {
        state.demands.lovebox = {
          ...state.demands.lovebox,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }
        if (data.current_page === 1) {
          state.demands.lovebox.data = data.data
        } else {
          state.demands.lovebox.data = state.demands.lovebox.data.concat(data.data)
        }
      }
    } else {
      if (status) {
        state.demands[status].gift = {
          ...state.demands[status].gift,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }

        if (data.current_page === 1) {
          state.demands[status].gift.data = data.data
        } else {
          state.demands[status].gift.data = state.demands[status].gift.data.concat(data.data)
        }
      } else {
        state.demands.gift = {
          ...state.demands.gift,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }

        if (data.current_page === 1) {
          state.demands.gift.data = data.data
        } else {
          state.demands.gift.data = state.demands.gift.data.concat(data.data)
        }
      }
    }
  },
  setDemandsCurIdx (state, {status, index}) {
    if (status) {
      state.demands[status].curIdx = index
    } else {
      state.demands.curIdx = index
    }
  },
  setSearchDemands (state, {type, data}) {
    if (type) {
      state.demands.search.need = {
        ...state.demands.search.need,
        total: data.total,
        curPage: data.current_page,
        nextPageUrl: data.next_page_url
      }

      if (data.current_page === 1) {
        state.demands.search.need.data = data.data
      } else {
        state.demands.search.need.data = state.demands.search.need.data.concat(data.data)
      }
    } else {
      state.demands.search.gift = {
        ...state.demands.search.gift,
        total: data.total,
        curPage: data.current_page,
        nextPageUrl: data.next_page_url
      }
      if (data.current_page === 1) {
        state.demands.search.gift.data = data.data
      } else {
        state.demands.search.gift.data = state.demands.search.gift.data.concat(data.data)
      }
    }
  },
  setSearchDemandsCurIdx (state, {index}) {
    state.demands.search.curIdx = index
  },
  setMergeList (state, data) {
    state.mergeList = {
      ...state.mergeList,
      total: data.total,
      data: data.current_page === 1 ? data.data : [...state.mergeList.data, ...data.data],
      curPage: data.current_page,
      nextPageUrl: data.next_page_url
    }
  },
  setMyDonates (state, {type, status, data}) {
    if (type) {
      if (status) {
        state.donates[status].need = {
          ...state.donates[status].need,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }
        if (data.current_page === 1) {
          state.donates[status].need.data = data.data
        } else {
          state.donates[status].need.data = state.donates[status].need.data.concat(data.data)
        }
      } else {
        state.donates.need = {
          ...state.donates.need,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }
        if (data.current_page === 1) {
          state.donates.need.data = data.data
        } else {
          state.donates.need.data = state.donates.need.data.concat(data.data)
        }
      }
    } else {
      if (status) {
        state.donates[status].gift = {
          ...state.donates[status].gift,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }
        if (data.current_page === 1) {
          state.donates[status].gift.data = data.data
        } else {
          state.donates[status].gift.data = state.donates[status].gift.data.concat(data.data)
        }
      } else {
        state.donates.gift = {
          ...state.donates.gift,
          total: data.total,
          curPage: data.current_page,
          nextPageUrl: data.next_page_url
        }
        if (data.current_page === 1) {
          state.donates.gift.data = data.data
        } else {
          state.donates.gift.data = state.donates.gift.data.concat(data.data)
        }
      }
    }
  },
  setDonatesCurIdx (state, {status, index}) {
    if (status) {
      state.donates[status].curIdx = index
    } else {
      state.donates.curIdx = index
    }
  },
  resetSectionDeals (state, types) {
    const type1 = types[0]
    const type2 = types[1]
    const type3 = types[2]
    if (type3) {
      state[type1][type2][type3] = {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    } else {
      state[type1][type2] = {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    }
  },
  resetDeals (state) {
    state.demands = {
      ...state.demands,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      lovebox: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      requesting: {
        ...state.demands.requesting,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        lovebox: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      remitting: {
        ...state.demands.remitting,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        lovebox: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      remitted: {
        ...state.demands.remitted,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        lovebox: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      sent: {
        ...state.demands.sent,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        lovebox: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      finished: {
        ...state.demands.finished,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        lovebox: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      }
    }
    state.donates = {
      ...state.donates,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      init: {
        ...state.donates.init,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      remitting: {
        ...state.donates.remitting,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      remitted: {
        ...state.donates.remitted,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      },
      sent: {
        ...state.donates.sent,
        gift: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        },
        need: {
          total: 0,
          curPage: 0,
          data: [],
          nextPageUrl: '//'
        }
      }
    }
    state.category = {
      gift_request: {
        requesting_total: '',
        remitting_total: '',
        remitted_total: '',
        sent_total: '',
        finished_total: '',
        lovebox_not_thank_total: '',
        lovebox_remitted_total: '',
        lovebox_remitting_total: '',
        lovebox_sent_total: ''
      },
      need_donate: {
        init_total: '',
        remitting_total: '',
        remitted_total: '',
        sent_total: ''
      }
    }
  },
  resetSearchDemand (state) {
    state.demands.search = {
      curIdx: state.demands.search.curIdx,
      gift: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      },
      need: {
        total: 0,
        curPage: 0,
        data: [],
        nextPageUrl: '//'
      }
    }
  },
  setPalmBoxNotTakeOrders (state, {gift_requests: giftRequests, need_donates: needDonates}) {
    state.palmNotTakeOrders = {
      giftRequests,
      needDonates
    }
  },
  setPayDealInfo (state, data) {
    state.payDealInfo = data
  },
  setUpdateChatroomInfo (state, { need, type, dealId = 0, directUserId = 0, oldDealId = 0 }) {
    state.updateChatroomInfo = {
      need,
      type,
      dealId,
      directUserId,
      oldDealId
    }
  },
  setDealDetailInfo (state, { type, deal }) {
    state.dealInfo = deal
    state.dealType = type
  },
  updateSentDonates (state, { type, data }) {
    for (let item of state.donates.sent[type].data) {
      if (item.id === data.id) {
        item.remind_at = data.remind_at
      }
    }
  },
  setUpdateChatRoomDealInfo (state, deal) {
    state.updateChatroomDealInfo = deal
  },
  setLoveOrderStatus (state, { orderId, status }) {
    console.log('setLoveOrderStatus', orderId, status)
    for (let order in state.demands.sent.lovebox.data) {
      if (order.id === orderId) {
        order.status = status
        break
      }
    }
    for (let order in state.demands.finished.lovebox.data) {
      if (order.id === orderId) {
        order.status = status
        break
      }
    }
    state.demands.sent.lovebox.data = [...state.demands.sent.lovebox.data]
    state.demands.finished.lovebox.data = [...state.demands.finished.lovebox.data]
  }
}

export default{
  state,
  actions,
  mutations
}
